import { ChevronLeft } from "lucide-react";
import Link from "next/link";

export const BrandLabel = ({ brand }) => {

    const shouldShowBrandInfo =
        !!brand?.custom_fields?.brand_identity
    // !!brand?.custom_fields?.custom_description;

    if (!shouldShowBrandInfo) return null;

    return (
        <>
            {brand?.custom_fields.brand_identity === "iranian_brand" ? (
                <div className="bg-jmt-primary-100 rounded-xl text-jmt-primary-800 font-bold text-[10px] lg:text-xs px-1 py-0.5 lg:p-1">
                    برند ایرانی
                </div>
            ) : brand?.custom_fields.brand_identity === "iranian_production" ? (
                <div className="bg-jmt-green-100 rounded-xl text-jmt-green-700 font-bold text-[10px] lg:text-xs px-1 py-0.5 lg:p-1">
                    تولید ایران
                </div>
            ) : brand?.custom_fields.brand_identity === "iranian_designer" && (<div className="bg-jmt-blue-100 rounded-xl text-jmt-blue-700 font-bold text-[10px] lg:text-xs px-1 py-0.5 lg:p-1">
                طراح ایرانی
            </div>)
            }
        </>
    );
}


export const BrandLabelDescription = ({ brand }) => {

    const shouldShowBrandInfo =
        !!brand?.custom_fields?.brand_identity &&
        !!brand?.custom_fields?.custom_description;

    if (!shouldShowBrandInfo) return null;

    return (
        <>
            <div className="lg:border border-jmt-neutral-200 rounded-md  lg:mt-6 px-4 my-5 md:px-10 lg:p-3">
                <div className="flex items-center justify-between pb-3">
                    {brand?.custom_fields.brand_identity === "iranian_brand" ?
                        (<span className="text-sm font-bold text-jmt-primary-800">برند ایرانی </span>
                        ) : brand?.custom_fields.brand_identity === "iranian_production" ? (
                            <span className="text-sm font-bold text-jmt-green-700">  تولید ایران </span>
                        ) : brand?.custom_fields.brand_identity === "iranian_designer" &&
                        (<span className="text-sm font-bold text-jmt-blue-700">طراح ایرانی </span>
                        )}

                    <ChevronLeft size={20} className="text-jmt-neutral-700" />
                </div>
                <Link href={brand?.custom_fields?.custom_link?.url || ""}>
                    <p className="text-[13px] text-jmt-neutral-700 line-clamp-2">
                        {brand?.custom_fields?.custom_description}
                    </p>
                </Link>
            </div>
        </>
    )
}

